// extracted by mini-css-extract-plugin
export default {"boxRockets":"BoxRockets_boxRockets__ETdk+","boxRockets__rocket":"BoxRockets_boxRockets__rocket__YRq4B"};